var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialsBubblesBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.29 171.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aca7bf;}.cls-2{fill:#7aadaa;}.cls-3{fill:#6e94bb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Page",
    "data-name": "Home Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PANEL_1:_SLIDER:_Testimonials",
    "data-name": "PANEL 1: SLIDER: Testimonials"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circles_behind_testimonials",
    "data-name": "Circles behind testimonials"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Purple_Circle",
    "data-name": "Purple Circle",
    className: "cls-1",
    cx: 318.98,
    cy: 11.64,
    r: 11.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Green_circle",
    "data-name": "Green circle",
    className: "cls-2",
    cx: 366.13,
    cy: 152.89,
    r: 18.16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Blue_circle",
    "data-name": "Blue circle",
    className: "cls-3",
    cx: 16.89,
    cy: 70.15,
    r: 16.89
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsBubblesBg);
export default __webpack_public_path__ + "static/media/testimonials-bubbles-bg.39f5275bdde77220d479cca819fe8916.svg";
export { ForwardRef as ReactComponent };